module.exports = __webpack_public_path__ + "static/img/GreenBubble@2x.c0e2ffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/GreenBubble@2x.png
// module id = qOIc
// module chunks = 0